import { extendObservable, action } from "mobx";

import { get, form, post, jsonParser } from "../utils/Client";
import { history } from "../";

class AuthenticationStore {
  constructor() {
    extendObservable(this, {
      isAuthenticated: false,

      me: {},

      schemas: [],

      testAuthenticated: action(() =>
        get("/me")
          .then((res) => {
            if (res.status === 401 || res.status === 403) {
              this.isAuthenticated = false;
              history.push("/login");
              return Promise.reject();
            } else {
              this.isAuthenticated = true;
              return res;
            }
          })
          .then(jsonParser)
          .then((data) => {
            this.me = data;
          })
      ),

      login: action((username, password) =>
        form("/authenticate", {
          body: { username, password },
        })
          .then((res) => {
            if (res.status === 403) {
              this.isAuthenticated = false;
              localStorage.apiToken = null;
              this.user = {};
              return Promise.reject("Usuário ou senha inválidos.");
            } else {
              this.isAuthenticated = true;
              return res.json();
            }
          })
          .then((data) => {
            console.log(data);
            if (data.user.role === "ADMIN" || data.user.role === "EXPERT") {
              this.me = data.user;
              localStorage.apiToken = data.token;
            } else {
              return Promise.reject("Usuário ou senha inválidos.");
            }
          })
      ),

      register: action((name, email, password) =>
        post("/register", {
          body: { name, email, password },
          credentials: "omit",
        })
      ),

      logout: action(async () => {
        this.isAuthenticated = false;
        this.user = {};
        localStorage.clear();  
      }),

      hasRole: action(
        (role) =>
          this.me.perfil &&
          this.me.perfil.autorizacoes.filter((a) => a.nome === role).length > 0
      ),
    });
  }
}

export default new AuthenticationStore();
